import GroupNotificationPopup from './group_notification_popup'
import MagnificPopup from './magnific_popup'
import { createRoot } from 'react-dom/client'
import { handleMissingAvatar } from './shared_functions'

class Notification extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visibleGroupNotification: false
    }
  }

  componentDidMount() {
    window.magnify()
  }

  updateNotification(data, e) {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    this.props.updateNotification(this.props.notification.id, data)
  }

  showGroupNotification(e) {
    e.preventDefault()
    this.setState({ visibleGroupNotification: true })

    const content = (
      <GroupNotificationPopup
        id={this.props.notification.id}
        hideGroupNotification={this.hideGroupNotification.bind(this)}
        notificationsPath={this.props.notificationsPath}
        updateParentNotification={this.updateNotification.bind(this)}
      />
    )

    if (window.reactMagnificPopup) {
      window.reactMagnificPopup.setState({ visible: true, content: content })
    } else {
      const magnific_popup_dom = document.getElementById('react-magnific-popup')
      if (magnific_popup_dom) {
        const root = createRoot(magnific_popup_dom)
        root.render(
          React.createElement(MagnificPopup, {
            content: content,
            visible: true,
            size: ''
          })
        )
      }
    }
  }

  hideGroupNotification() {
    this.setState({ visibleGroupNotification: false })
  }

  readAllInGroup(e) {
    e.preventDefault()
  }

  unreadAllInGroup(e) {
    e.preventDefault()
  }

  render() {
    let disableTurbolinks = this.props.notification.account_id != window.appData.account_id

    let buttons
    switch (this.props.notification.event) {
      case 'invitation':
        buttons = (
          <div className="buttons">
            <div className="btn-group">
              {this.props.notification.status == 'pending' ? (
                <>
                  <a
                    href={this.props.notification.confirm_invitation_path}
                    data-method="patch"
                    className="btn btn-sm btn-thin"
                  >
                    <i className="cico fa fa-check"></i>
                    {I18n.t('notification-confirm')}
                  </a>
                  <a
                    href="#"
                    onClick={this.updateNotification.bind(this, { status: 'ignored' })}
                    className="btn btn-sm btn-thin"
                  >
                    {I18n.t('notification-ignore')}
                  </a>
                </>
              ) : null}
            </div>
          </div>
        )
        break
      case 'notification':
      case 'group_notification':
      case 'event_status_change':
        buttons = (
          <div className="buttons">
            <div className="btn-group">
              {this.props.notification.import_event_path ? (
                <a onClick={() => {window.postMessage({type: 'close_magnific_popup'}) }} href={this.props.notification.import_event_path} className="btn btn-sm btn-thin ajax-popup">
                  {I18n.t('view')}
                </a>
              ) : null}

              {this.props.notification.status == 'unread' ? (
                <a
                  href="#"
                  onClick={this.updateNotification.bind(this, { status: 'read' })}
                  className="btn btn-sm btn-thin"
                >
                  <i className="cico fa-light fa-check"></i>
                  {I18n.t('notification-read')}
                </a>
              ) : null}

              {this.props.notification.status == 'read' ? (
                <a
                  href="#"
                  onClick={this.updateNotification.bind(this, { status: 'unread' })}
                  className="btn btn-sm btn-thin"
                >
                  <i className="cico fa-light fa-minus"></i>
                  {I18n.t('notification-unread')}
                </a>
              ) : null}
            </div>
          </div>
        )
        break
      case 'event_invitation':
        buttons = (
          <div className="buttons">
            <div className="btn-group">
              {this.props.notification.status == 'unread' ? (
                <>
                  <a
                    href="#"
                    onClick={this.updateNotification.bind(this, {
                      status: 'read',
                      event_user_status_helper: 'accepted'
                    })}
                    className="btn btn-sm btn-thin"
                  >
                    <i className="cico fa fa-check"></i>
                    {I18n.t('notification-confirm')}
                  </a>
                  <a
                    href="#"
                    onClick={this.updateNotification.bind(this, {
                      status: 'read',
                      event_user_status_helper: 'rejected'
                    })}
                    className="btn btn-sm btn-thin"
                  >
                    {I18n.t('refuse')}
                  </a>
                  <a
                    href="#"
                    onClick={this.updateNotification.bind(this, {
                      status: 'read',
                      event_user_status_helper: 'pending'
                    })}
                    className="btn btn-sm btn-thin"
                  >
                    {I18n.t('without-answer')}
                  </a>
                </>
              ) : null}
            </div>
          </div>
        )
        break
    }
    return (
      <div className="notification">
        <div className="avatar">
          <div className="image-wrapper">
            <div className="hexagon">
              <img src={this.props.notification.avatar_url} alt="" onError={handleMissingAvatar} />
            </div>
            {this.props.notification.bot ? <div className="bot-mark">BOT</div> : null}
          </div>
        </div>
        <div className="body">
          {this.props.notification.event == 'group_notification' ? (
            <div data-turbolinks="false">
              {I18n.t('group-notification-text', { link: '' })}

              <a href="#" onClick={this.showGroupNotification.bind(this)}>
                {`${I18n.t('group-notification-subtext')}: ${this.props.notification.group_notification_ids.length}`}
              </a>
            </div>
          ) : (
            <div
              data-turbolinks={disableTurbolinks ? 'false' : 'true'}
              dangerouslySetInnerHTML={{ __html: this.props.notification.message_html }}
            ></div>
          )}
          <small title={moment.parseZone(this.props.notification.created_at).format('L')}>
            {moment.parseZone(this.props.notification.created_at).fromNow()}
          </small>
        </div>
        {buttons}
      </div>
    )
  }
}

export default Notification
